import React, {useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from "primereact/multiselect";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';

import { getReseUserTableDataInit, getReseUserTableDivisionInit,getReseUserTableStoreInit, getReseUserTableStatusInit, updateReseUserTableDataInit } from './redux/actions';
import ReseStoreInfoDialouge from '../store/ReseStoreInfoDialouge';
import { Toast } from 'primereact/toast';
import './ReseUser.scss';

const ReseUser = () => {
    const [tableFilters, setTableFilters] = useState(null);
    const [reseUserInfoDialouge, setReseStoreInfoDialouge] = useState(null);
    const [filterCondition, setFilterCondition] = useState("")
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: "firstName",
        sortOrder: 1
    });
    const reseUserTableRef = useRef(null);

    const reseUserTableData = useSelector((state) => state.reseUser.reseUserTableData);
    const totalRecords = useSelector((state) => state.reseUser.totalRecords);
    console.log("totalRecords",totalRecords);
    console.log("details",reseUserTableData);
    const reseUserTableDivisions = useSelector((state) => state.reseUser.reseUserTableDivisionData)
    console.log("Divisions",reseUserTableDivisions);
    const reseUserTableStores = useSelector((state => state.reseUser.reseUserTableStoreData))
    console.log("Stores",reseUserTableStores);
    const reseUserTableStatus = useSelector((state) => state.reseUser.reseUserTableStatusData)
    console.log("Status", reseUserTableStatus);
    const dispatch = useDispatch();
    const toast = useRef(null);
    const updateSuccess = useSelector((state) => state.reseUser.updateSuccess);
    const updateError = useSelector((state) => state.reseUser.updateError);
    useEffect(() => {
        fetchReseUserTableData();
        initializeTableFilters();
    },[]);

    useEffect(() => {
        fetchReseUserTableDivisions()
        fetchReseUserTableStatus()
        fetchReseUserTableStores()
    },[]);

    useEffect(() => {
        if (updateSuccess) {
            toast.current.show({ severity: 'success', summary: 'Success', detail: 'User Data updated successfully', life: 3000 });
            fetchReseUserTableData();
        } else if (updateError) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update User Data', life: 3000 });
        }
    }, [updateSuccess, updateError]); 

    const fetchReseUserTableData = (params=lazyParams, filters=filterCondition) => {
        const sortDirection= params.sortOrder== -1?'DESC' : 'ASC';
        const filterConditionPayload = constructFilterParams(filters);
        dispatch(getReseUserTableDataInit(
            params.page,
            params.rows,
            params.sortField,
            sortDirection,
            filterConditionPayload
        ));
    }

    const constructFilterParams = (filterConditions) => {
        if (!filterConditions || typeof filterConditions !== "object") {
          return ""; 
        }
        const queryParams = [];
        Object.keys(filterConditions).forEach((key) => {
          const filter = filterConditions[key];
          const constraints = filter?.constraints;
          console.log(constraints);
          if (constraints && constraints.length > 0) {
            const { value, matchMode } = constraints[0];
            if (value !== undefined && value !== null && value !== "") {
              queryParams.push(
                `${encodeURIComponent(key)}&${encodeURIComponent(matchMode)}&${encodeURIComponent(value)}`
              );
            }
          }
        });
        return queryParams.join(",");
      };


    const fetchReseUserTableDivisions = () => {
        const divisionColumnPayload = {
            targetColumn: "division",
            tableName: "store"
        }
        dispatch(getReseUserTableDivisionInit(divisionColumnPayload));
    }
    const fetchReseUserTableStores = () => {
        const storeColumnPayload = {
            targetColumn: "store_id",
            tableName: "store"
        }
        dispatch(getReseUserTableStoreInit(storeColumnPayload));
    }


    const fetchReseUserTableStatus = () => {
        const statusColumnPayload = {
            targetColumn: "status",
            tableName: "onboard_status"
        }
        dispatch(getReseUserTableStatusInit(statusColumnPayload));
    }

    const initializeTableFilters = () => {
        setTableFilters({
                    global: {value: null, matchMode: FilterMatchMode.CONTAINS},
                    firstName: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                      },
                    lastName: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },  
                    email: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                    department: {
                        operator: FilterOperator.AND,
                        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },            
                    divisions: {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                    stores: {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                    role: {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                    module: {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    },
                    status: {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
                    }
                });
    };

    const onPage = (event) => {
        console.log(event);
        const onPageChangeParams = {
            ...lazyParams,
            first:event.first,
            rows:event.rows,
            page:event.page
        }
        setLazyParams(onPageChangeParams);
        fetchReseUserTableData(onPageChangeParams);
    }

    const onSort = (event) => {
        console.log(event);
        const onSortParams = {
            ...lazyParams,
            sortField: event.sortField,
            sortOrder: event.sortOrder
        }
        setLazyParams(onSortParams);
        fetchReseUserTableData(onSortParams);
    }

    const onFilter = (filters) => {
        console.log(filters);
        setFilterCondition(filters);
        console.log("filterCondition",filterCondition);
        const onFilterParams = {
            ...lazyParams,
            first: 0,
            page: 0
        }
        setLazyParams(onFilterParams);
        fetchReseUserTableData(onFilterParams,filters);
    }


    const divisionTemplate = ({ divisions }) => {
		return (
			<>
				{divisions && divisions.length > 0 ? (
					divisions.join(", ")
				) : (
					<span style={{ marginLeft: "50%" }}>-</span>
				)}
			</>
		);
	};
    const storeTemplate = ({ stores }) => {
		return (
			<>
				{stores && stores.length > 0 ? (
					stores.join(", ")
				) : (
					<span style={{ marginLeft: "50%" }}>-</span>
				)}
			</>
		);
	};
    const infoBodyTemplate = (rowData) => {
        return <i className="pi pi-info-circle" onClick={() => setReseStoreInfoDialouge(rowData)}/>
    }
    const textEditor = (options) => {
        return <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    }

    const divisionsEditor = (options) => {
        const selectedValues = options.value;
        return <MultiSelect value={selectedValues} options={reseUserTableDivisions}  onChange={(e) => options.editorCallback(e.value)} filter/>;
    }
    
    const storesEditor = (options) => {
        return <MultiSelect value={options.value} options={reseUserTableStores} onChange={(e) => options.editorCallback(e.value)} filter/>;
    }


    const statusEditor = (options) => {
        return <Dropdown value={options.value} options={reseUserTableStatus} onChange={(e) => options.editorCallback(e.value)} />;
    }

    const onRowEditComplete = (e) => {
        dispatch(updateReseUserTableDataInit(e.newData));
    }
    
    return (
        <div className="rese-user-container container-fluid">
              <Toast ref={toast} position="bottom-center"/>
            <ReseStoreInfoDialouge dialougeData={reseUserInfoDialouge} setDialougeData={setReseStoreInfoDialouge}/>
            <p className="page-label">
                RESE <i className="pi pi-angle-right"/> Users
            </p>
            <div className="d-flex justify-content-end">
                    <Button
                    name='refresh'
                    className='p-button-text'
                    icon="pi pi-refresh"
                    onClick={() => fetchReseUserTableData()}
                    />
                    <Button
                    name='download'
                    className='p-button-text'
                    icon="pi pi-download"
                    onClick={() => reseUserTableRef.current.exportCSV()}
                    />
            </div>
            <DataTable
            value={reseUserTableData}
            ref={reseUserTableRef}
            showGridlines
            lazy
            totalRecords={totalRecords}
            filters={tableFilters}
            filterDisplay='menu'
            onFilter={(e) => onFilter(e.filters)}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            onSort={onSort}
            first={lazyParams.first}
            rows={lazyParams.rows}
            rowsPerPageOptions={[5, 10, 20]}
            onPage={onPage}
            editMode='row'
            onRowEditComplete={onRowEditComplete}
            paginator
            paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
           currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                <Column field="firstName" header="First Name" editor={(options) => textEditor(options)} sortable filter/>
                <Column field="lastName" header="Last Name" editor={(options) => textEditor(options)} sortable filter/>
                <Column field="email" header="Email" editor={(options) => textEditor(options)} sortable filter/>
                <Column field="department" header="Department" editor={(options) => textEditor(options)} sortable filter/>
                <Column field="divisions" header="Divisions" body={divisionTemplate} editor={(options) => divisionsEditor(options)} sortable filter/>
                <Column field="stores" header="Stores" body={storeTemplate} editor={(options) => storesEditor(options)} sortable filter/>
                <Column field="role" header="Role" editor={(options) => textEditor(options)} sortable filter/>
                <Column field="module" header="Module" editor={(options) => textEditor(options)} sortable filter/>
                <Column field="status" header="Status" editor={(options) => statusEditor(options)} sortable filter/>
                <Column header="Info" body={infoBodyTemplate}/>
                <Column rowEditor bodyStyle={{textAlign: 'center', minWidth: '7rem'}}/>

            </DataTable>

        </div>
    );
}

export default ReseUser;